module.exports = __webpack_public_path__ + "img/step-5.ff0f8229.png";